import { NavButtonGamepad } from "../../../react-unboared";
import { TEXT_COLOR, BACKGROUND_COLOR } from "../config/Const";

const NavButton = (props) => {
    return (
        <NavButtonGamepad {...props} color={TEXT_COLOR} backgroundColor={BACKGROUND_COLOR}/>
    );
}

export default NavButton;